import { type IconName } from '@/components/Icon'
import { type LegendServiceType } from '@/features/jobs/legends/legend-service-type'

export const serviceTypeIcons: Record<LegendServiceType, IconName> = {
  Tax: 'docs',
  Consultation: 'chat-bubbles',
  Bookkeeping: 'buildings',
  Misc: 'rocket',
}
